import { render, staticRenderFns } from "./ProductSizesRows.vue?vue&type=template&id=115ba57a&scoped=true&"
import script from "./ProductSizesRows.vue?vue&type=script&lang=js&"
export * from "./ProductSizesRows.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizesRows.vue?vue&type=style&index=0&id=115ba57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ba57a",
  null
  
)

export default component.exports